import styles from '../node.module.css'

export interface NodeGroupProps {
  children: React.ReactNode
}

export const NodeGroup = ({ children }: NodeGroupProps): JSX.Element => {
  return <div className={styles.group}>{children}</div>
}
